// extracted by mini-css-extract-plugin
export default {"home_page_conatiner":"styles_home_page_conatiner__q7Di4"};